import View from './View';

export const navTitle = document.querySelector('.side-nav__logo--name');
export const navItem = document.querySelector('.side-nav__item');
